// src/data/AwarenessActivitiesData.js

export const earthDayActivities = [
  {
    category: 'Creative Expression',
    activities: [
      { id: 'creative-poster', name: 'Poster or Slogan Contest', description: 'Themes like “Our Power, Our Planet” or “Planet vs. Plastics” spark powerful visuals.' },
      { id: 'creative-crafts', name: 'Eco-Friendly Crafts', description: 'Use recycled materials to make bird feeders, seed bombs, or tote bags with green messages.' },
      { id: 'creative-photography', name: 'Nature Photography or Rock Painting', description: 'Capture or decorate natural elements with Earth-positive messages.' },
    ],
  },
  {
    category: 'Educational Activities',
    activities: [
      { id: 'edu-quiz', name: 'Earth Day Quiz', description: 'Test knowledge on climate change, wildlife, and sustainability.' },
      { id: 'edu-documentary', name: 'Environmental Documentary Screening', description: 'Follow up with a discussion or reflection journal.' },
      { id: 'edu-essay-poem', name: 'Essay or Poem Writing', description: 'Topics like “A Letter to Mother Earth” or “My Green Promise.”' },
      { id: 'edu-classroom-debate', name: 'Classroom Debate', description: 'Topics like “Is fast fashion harming the planet?”' },
    ],
  },
  {
    category: 'Interactive & Group Events',
    activities: [
      { id: 'group-role-plays', name: 'Role Plays or Skits', description: 'Act out scenes on pollution, conservation, or climate justice.' },
      { id: 'group-clean-up', name: 'Clean-Up Drive', description: 'Assign zones around the school or nearby parks for litter collection.' },
      { id: 'group-lights-off', name: '“Lights Off” Hour', description: 'Demonstrate energy conservation by switching off lights and electronics.' },
    ],
  },
  {
    category: 'STEM & Innovation',
    activities: [
      { id: 'stem-science-fair', name: 'Science Fair on Green Tech', description: 'Showcase solar ovens, water filters, or composting models.' },
      { id: 'stem-water-pollution', name: 'Water Pollution Experiment', description: 'Simulate pollutants and discuss their impact on aquatic life.' },
      { id: 'stem-vertical-garden', name: 'Build a Vertical Garden', description: 'Teach space-saving sustainability.' },
    ],
  },
  {
    category: 'Whole-School Engagement',
    activities: [
      { id: 'school-assembly', name: 'Earth Day Assembly', description: 'Include speeches, pledges, and performances.' },
      { id: 'school-pledge-wall', name: 'Green Pledge Wall', description: 'Students commit to eco-friendly habits—short showers, reusable bottles, etc.' },
      { id: 'school-waste-free', name: 'Waste-Free Lunch Day', description: 'Encourage reusable containers and zero-waste meals.' },
    ],
  },
  {
    category: 'Hands-On Environmental Projects',
    activities: [
      { id: 'proj-tree-planting', name: 'Tree Planting or School Garden', description: 'Let students dig in—literally! Teach them about carbon absorption and biodiversity.' },
      { id: 'proj-composting', name: 'Composting Station', description: 'Set up a bin for organic waste and explain decomposition and soil enrichment.' },
      { id: 'proj-recycling', name: 'Recycling Challenge', description: 'Organize a competition to collect and sort recyclables. Reward the greenest class!' },
    ],
  },
];